export default __webpack_public_path__ + "static/media/guacamole.c840ec03.wav";